
Checkout.Cart.SaveForLater.Item = function(checkout, cart) {
	var savedItem = this;

	this.productID =
	this.unitprice =
	this.data =
	this.$row =
	this.$content =
	this.$loadingOverlay =
	this.$loadingMsg =
	this.$removeOverlay =
	this.$error =
	this.$errorMsg =
	this.$warning =
	this.$warningMsg =
	this.$info =
	this.$infoMsg =
	this.$optionContainer =
	this.$contentTmpl =
	this.$contentsTitle = false;

	this.init = function() {

		savedItem.$row = cart.$savedItemTpl.clone(true).attr('id', '');

		savedItem.$content = savedItem.$row.find('.saved-item-content');
		savedItem.$loadingOverlay = savedItem.$row.find('.loading-overlay');
		savedItem.$loadingMsg = savedItem.$loadingOverlay.find('.msg-text');
		savedItem.$removeOverlay = savedItem.$row.find('.confirm-remove');
		savedItem.$error = savedItem.$row.find('.saved-item-error');
		savedItem.$errorMsg = savedItem.$error.find('.msg-text');
		savedItem.$warning = savedItem.$row.find('.saved-item-warning');
		savedItem.$warningMsg = savedItem.$warning.find('.msg-text');
		savedItem.$info = savedItem.$row.find('.saved-item-info');
		savedItem.$infoMsg = savedItem.$info.find('.msg-text');
		savedItem.$displayPrice = savedItem.$row.find('.saved-item-price');
		savedItem.$optionContainer = savedItem.$row.find('.selected_options');
		savedItem.$contentsTitle = savedItem.$row.find('.selected_opt_head');
		savedItem.$contentsTmpl = savedItem.$row.find('#tmpl-opt_list');

		cart.$savedContainer.append(savedItem.$row);

	};

	this.add = function(item) {
		//console.log(item);
        var data        = item.data || item.item, // item.data (cart), item.item (sessionStorage / wishlist)
			options     = item.options || item.kitContents || []; // item.options (cart), item.kitContents (sessionStorage / wishlist)

		savedItem.options = options;
		savedItem.data = data;

		savedItem.productID = data.productID;
		savedItem.productPath = data.productPath;
		
		var productKey = cart.saveForLater.getProductKey(savedItem.productID, savedItem.data.pdk);
		cart.savedItems[productKey] = savedItem;

		savedItem.$row.attr('id', 'saved-item-'+productKey);
		savedItem.$row.find('.savedDescLink').attr('href', fixNavState('/'+ savedItem.productPath));

		if(data.pdk) {
			savedItem.$row.addClass('pdkProduct');
			savedItem.$contentsTitle.html('Selected Options');
		}
		if(data.kit) {
			savedItem.$row.addClass('kitProduct');
			savedItem.$contentsTitle.html('Kit Contents');
		}
		
		if(options && options.length) {
			for(var i = 0; i < options.length; i ++) {
				new Checkout.Cart.SaveForLater.Item.Option(savedItem).add(options[i]);
			}
		}
		
		for (var k in savedItem.data) {
			var $el = savedItem.$row.find('.saved-item-'+k);

			if (!$el.length)
				continue;

			if (k == 'pretty_partnumber') {
				if (checkout.user)
					$el.html(
						'<a href="'+checkout.config.productAdminEditURL+savedItem.data[checkout.config.cartItemProdIDKey]+'" target="_blank">'
							+ savedItem.data[k]
						+ '</a>'
					);
				else
					$el.html(savedItem.data[k]);
			} else if (k == 'qty')
				$el.val(savedItem.data[k]);
			else if (k == 'stockStatusIcon')
				$el.addClass('status-' + savedItem.data[k]);
			else if (k == 'mainImage') {
				if (savedItem.data.mainImage){
					var prodImgSize = pointsBreak.getWidth() > 480 ? checkout.config.prodImgSize.small : 300;
					prodImgSize !== undefined ? $el.attr('src', CDNproduct + '/' + savedItem.data.mainImage + '_x'+prodImgSize+'.jpg') : $el.attr('src', CDNpath + '/img/bg_no-image_100x75.jpg');
				}
			} else if (k == 'brand') {
				if (savedItem.data.brand)
					$el.attr({
						'src': CDNpath + '/img/brands/' + savedItem.data.brand.name + '.gif',
						'width': savedItem.data.brand.width,
						'height': savedItem.data.brand.height,
						'alt': savedItem.data.brand.name
					});
			} else if (k == 'shipfree') {
				if (parseInt(savedItem.data.shipfree))
					$el.show();
			} else if (k == 'shipFreeEligible') {
				if (parseInt(savedItem.data.shipFreeEligible))
					$el.show();
			} else if (k == 'groundshipOnly') {
				if (parseInt(savedItem.data.groundshipOnly))
					$el.show();
			} else if (k == 'notifyMe') {
				if (parseInt(savedItem.data.notifyMe)) {
					$el.find('a').attr('data-productid',savedItem.data.productID);
					$el.find('a').css('cursor', 'pointer');
					$el.show();
				}
			} else if (k == "stockStatusLong") {
				$el.attr("data-content", savedItem.data[k]).removeClass("disabled");
			} else if (k == "stockStatus") {
				if (savedItem.data['stockStatusIcon'] === '1')
					$el.addClass('redtxt').html(savedItem.data[k]);
				else
					$el.html(savedItem.data[k]);
			} else
				$el.html(savedItem.data[k]);
		}

		savedItem.setPrice(savedItem.data.unitprice, savedItem.data.price_retail, savedItem.data.availablePricing);

		savedItem.$content.show();
		
		return savedItem;
	};
	
	this.setPrice = function(price, retail, availablePricing) {
		savedItem.unitprice = parseFloat(price);
		savedItem.$row.find('.saved-item-price').html(savedItem.unitprice.toMoney());
		savedItem.$row.find('.saved-item-price-edit input').val(savedItem.unitprice.toMoney());
		savedItem.extendPrice();

		price  = parseFloat(price);
        retail = parseFloat(retail);

        if(price < retail) savedItem.saleDiscount(price, retail, availablePricing);
	};

	this.extendPrice = function() {
		savedItem.$row.find('.saved-item-extendprice').html(
			commaSeparate((savedItem.data.qty * savedItem.unitprice).toMoney())
		);
	};

	this.saleDiscount = function(price, retail, availablePricing) {
        var discountPercentage = (retail - price) / retail * 100;
        // round the discount to the nearest percent
        discountPercentage = parseInt(discountPercentage + 0.5, 10);

        savedItem.$row.find(".pricecut").show().html("$" + retail.toMoney());

        // Do not show the on sale text if this is a wholesale/manual price
        if(availablePricing
            && price != availablePricing.retail
            ) {
            return;
        }

        var saleText = "ON SALE";
        if(availablePricing.limitedQty) {
            saleText += " - Limited Qty";
        }
        else if(discountPercentage >= 10) {
            saleText += " - Save " + discountPercentage + "%";
        }

        savedItem.$row.find(".onsale").show().find("span").html(saleText);
    };
	
	this.remove = function() {
		savedItem.$row.remove();
		var productKey = cart.saveForLater.getProductKey(savedItem.productID, savedItem.data.pdk);
		delete cart.savedItems[productKey];
	};
	
	this.changeQty = function(qty) {
		savedItem.data.qty = qty;
		savedItem.setPrice(savedItem.data.unitprice, savedItem.data.price_retail, savedItem.data.availablePricing);
	}

	this.loading = function(loadingMsg) {
		if (loadingMsg) {
			savedItem.$loadingMsg.html(loadingMsg);
			savedItem.$loadingOverlay.show();
			checkout.alignMiddle(savedItem.$loadingOverlay.find('.msg'), savedItem.$loadingOverlay);
			this.clearMessages();
		} else
			savedItem.$loadingOverlay.hide();
	};

	this.error = function(errorMsg) {
		if (errorMsg) {
			savedItem.$errorMsg.html(errorMsg);
			savedItem.$error.show();
		} else {
			savedItem.$error.hide();
			savedItem.$errorMsg.html('');
		}
	};

	this.warning = function(warningMsg) {
		if (warningMsg) {
			savedItem.$warningMsg.html(warningMsg);
			savedItem.$warning.show();
		} else {
			savedItem.$warning.hide();
			savedItem.$warningMsg.html('');
		}
	};

	this.info = function(infoMsg) {
		if (infoMsg) {
			savedItem.$infoMsg.html(infoMsg);
			savedItem.$info.show();
		} else {
			savedItem.$info.hide();
			savedItem.$infoMsg.html('');
		}
	};
	
	this.clearMessages = function() {
		this.error();
		this.warning();
		this.info();
	}

	this.init();
};

